module.exports = __webpack_public_path__ + "static/img/Operation-management-platform1.1dc66af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Operation-management-platform1.jpg
// module id = 0pgd
// module chunks = 0